module.exports = __webpack_public_path__ + "static/media/KaTeX_Math-BoldItalic.d9377b53.ttf";